import { Injectable } from '@angular/core';
import { APIService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class SpotCountUpdateService {

  constructor(private readonly apiService: APIService) { }

  CheckValidityOnSpotCountIncreaseDecrease(request) {
    return this.apiService.postWithAllResponse('GroupBooking/CheckValidityOnSpotCountIncreaseDecrease', request);
  }

  decreaseGroupBookingSpot(request) {
    return this.apiService.postWithAllResponse('GroupBooking/DecreaseGroupBookingSpot', request);
  }

  increaseGroupBookingSpot(request){
    return this.apiService.postWithAllResponse('GroupBooking/IncreaseGroupBookingSpot',request);
  }
}
